(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('setupApp')
        .constant('CONST_SETUP', {
            'GROUP_SERVICE': [{code:'CMA',name:'CMA'},
	                      {code:'CMI',name:'CMI'},
	                      {code:'BSU',name:'CMI'},
	                      {code:'FSU',name:'CMI'}]
        });
})();
